import { I18n } from '@calendly/i18n'

import { BaseNotificationSection } from '../base_notification_section'

export const TextRemindersSection = ({ eventType }) => (
  <BaseNotificationSection
    kind="invitee_sms_reminder"
    eventType={eventType}
    description={I18n.t('publisher.event_type_editor.sections.communications.text_reminders.description')}
  />
)
